const toLowerCase = val => typeof val === 'string' ? val.toLowerCase() : val;
export default toLowerCase;